import { ogImageMeta } from "@/lib/seo/og-image";
import { createFileRoute } from "@tanstack/react-router";
import { parseBlogSearch } from "@/lib/blog-search";
import { BlogIndex } from "@/components/insights/BlogIndexPage";
import { listPosts, listCategories } from "@/lib/wp.functions";

import { blogListSchemas } from "@/lib/seo/page-schema";
import { urlFor } from "@/lib/seo/schema";

export const Route = createFileRoute("/bg/blog/")({
  validateSearch: (s) => parseBlogSearch(s),
  loaderDeps: ({ search }) => ({ page: search.page ?? 1, category: search.category }),
  loader: async ({ deps }) => {
    const [posts, cats] = await Promise.all([
      listPosts({ data: { page: deps.page, perPage: 12, categorySlug: deps.category, locale: "bg" } }),
      listCategories({ data: { locale: "bg" } }),
    ]);
    return { posts, cats, page: deps.page, category: deps.category };
  },
  head: ({ loaderData }) => {
    const canonical = urlFor("bg", "/blog");
    return {
      meta: [
        { title: "Блог - статии за медийно разузнаване | Perceptica" },
        { name: "description", content: "Практични статии за медиен мониторинг, медийно разузнаване, медийни анализи и анализ на репутацията от екипа на Perceptica. Разгледайте най-новото." },
        { property: "og:title", content: "Блог - статии за медийно разузнаване | Perceptica" },
        { property: "og:description", content: "Практични статии за медиен мониторинг, медийно разузнаване, медийни анализи и анализ на репутацията от екипа на Perceptica. Разгледайте най-новото." },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonical },
        ...ogImageMeta("bg", "/blog"),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Блог - статии за медийно разузнаване | Perceptica" },
      { name: "twitter:description", content: "Практични статии за медиен мониторинг, медийно разузнаване, медийни анализи и анализ на репутацията от екипа на Perceptica. Разгледайте най-новото." },
    ],
    links: [
    ],
      scripts: blogListSchemas({
        locale: "bg",
        name: "Блог на Perceptica",
        description: "Анализи, изследвания и бележки от анализаторите на Perceptica",
        posts: loaderData?.posts?.posts?.map((p) => ({
          title: p.title.rendered.replace(/<[^>]*>/g, ""),
          slug: p.slug,
          datePublished: p.date,
        })),
      }),
    };
  },
  component: BlogIndex,
});
